// A7.17 support escalation rules + live breaches — module-local data layer. REAL
// backend (/admin/escalation-rules, /admin/escalation-breaches). Breaches are
// computed live against support_tickets (no auto-action).
import { api } from '@/lib/api'

export interface EscalationRule {
  id: number
  name: string
  unanswered_hours: number
  priority_filter: string
  enabled: boolean
}
export interface Breach {
  ticket_id: number
  subject: string
  priority: string
  age_hours: number
  rule: string
  rule_hours: number
}

export const fetchRules = (s?: AbortSignal) =>
  api.get<{ rules: EscalationRule[] }>('/admin/escalation-rules', s ? { signal: s } : undefined).then((d) => d.rules ?? [])
export const createRule = (body: { name: string; unanswered_hours: number; priority_filter: string }) =>
  api.post<{ id: number }>('/admin/escalation-rules', body)
export const toggleRule = (id: number, enabled: boolean) =>
  api.post(`/admin/escalation-rules/${id}/toggle`, { enabled })
export const deleteRule = (id: number) => api.del(`/admin/escalation-rules/${id}`)
export const fetchBreaches = (s?: AbortSignal) =>
  api.get<{ breaches: Breach[] }>('/admin/escalation-breaches', s ? { signal: s } : undefined).then((d) => d.breaches ?? [])

export const PRIORITIES = ['', 'low', 'normal', 'high', 'urgent'] as const

export const ES_STR = {
  title: 'Правила эскалации',
  desc: 'Открытые + без ответа > N часов → эскалация. Список ниже — тикеты, нарушающие правила сейчас',
  create: 'Новое правило',
  name: 'Название',
  hours: 'Часов без ответа',
  priority: 'Приоритет',
  anyPriority: 'любой',
  add: 'Добавить',
  delete: 'Удалить',
  breaches: 'Нарушают сейчас',
  ticket: 'Тикет',
  rule: 'Правило',
  age: 'Возраст (ч)',
  noBreaches: 'Нет нарушений — всё отвечено вовремя',
  noRules: 'Нет правил — создайте первое',
  done: 'Готово',
  failed: 'Ошибка',
} as const
